import useApi, { ApiOptions } from '../base/useApi';
import ProductionCompanyDTO from '@src/adapters/dto/productionCompany/ProductionCompanyDTO';

interface Params {}

interface Result {
  items: ProductionCompanyDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/production_company/list',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindProductionCompaniesListLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindProductionCompaniesListLazy;
